import { FieldProps, InputProps, useField } from 'informed';
import { InputWrapper, InputWrapperProps } from 'ui-forms/src/common';
import classNames from 'classnames';

interface CustomRangeProps extends InputProps, InputWrapperProps {
}

const CustomRange = (props: FieldProps<CustomRangeProps, string | number, object>) => {
  const { render, userProps, ref, fieldState, fieldApi } = useField(props);
  const { setValue, setTouched, setFocused } = fieldApi;
  const { maskedValue, showError, error } = fieldState;
  const { label, id, className, simple, icon, suffix, description, hidden, min = 0, max = 100, ...rest } = userProps;

  return render(
    <InputWrapper
      className={className}
      simple={simple}
      error={showError ? String(error) : undefined}
      description={description}
      hidden={hidden}
    >
      <div className="w-full">
        <div className="flex">
          <div className="grow">{label}</div>
          {icon}
        </div>
        <input
          ref={ref}
          id={id}
          className={classNames(
            'relative bg-red-700 mt-9',
            'after:content-[attr(value)] after:h-6 after:min-w-6 after:absolute after:-top-8 after:-ml-1 after:text-center after:bg-secondary-600 after:text-white after:rounded after:leading-6',
            'after:left-[calc((min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*100%)-(min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*16px))]',
            'before:absolute before:size-0 before:-top-2 before:ml-1 before:border-l-4 before:border-r-4 before:border-t-[5px] before:border-l-transparent before:border-r-transparent before:border-t-secondary-600',
            'before:left-[calc((min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*100%)-(min(attr(value_type(<number>)),attr(max_type(<number>)))/(attr(max_type(<number>))-attr(min_type(<number>)))*16px))]',
            { 'before:!left-0': Number(max) - Number(min) <= 0 },
            { 'after:!left-0': Number(max) - Number(min) <= 0 },
          )}
          {...rest}
          type="range"
          min={min}
          max={max}
          value={!maskedValue && maskedValue !== 0 ? 0 : maskedValue}
          onChange={(e) => {
            setValue(e.target.value, e);
          }}
          onBlur={(e) => {
            setTouched(true, e);
          }}
          onFocus={(e) => {
            setFocused(true, e);
          }}
        />
        {suffix}
      </div>
    </InputWrapper>
  )
}

export default CustomRange;
